/**
 * Deep, high-contrast status colors from the kx design system.
 * Mirrors the .kx-status--* chip classes in src/assets/scss/kairos.css —
 * keep both in sync when adding a state.
 */
export interface IStatusColor {
  bg: string;
  text: string;
}

export const KX_STATUS_COLORS: { [key: string]: IStatusColor } = {
  success: { bg: '#d3eedd', text: '#0a4b28' },
  pending: { bg: '#fae8c8', text: '#6b4306' },
  failed: { bg: '#fbdcd8', text: '#96170b' },
  expired: { bg: '#ebdcda', text: '#5c1812' },
  info: { bg: '#dbe7f7', text: '#173d75' },
};
